import { Component } from '@angular/core';
import { ValidationErrors, AbstractControl, Validators } from '@angular/forms';

@Component({ template: '' })
export class FormComponent {

  // min. 8 characters, consisting of min. 1 uppercase, 1 lowercase a digit and 1 special character
  protected validatorPatternPassword = Validators.pattern('^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\\W).*$');

  // name of the control to match to
  protected matchValues(matchTo: string): (AbstractControl) => ValidationErrors | null {
      return (control: AbstractControl): ValidationErrors | null => {
        return !!control.parent &&
          !!control.parent.value &&
          control.value === control.parent.controls[matchTo].value
          ? null
          : { isMatching: false };
      };
  }

}
